// src/hooks/useBrand.ts
import { BRAND_CONFIG, getBrandName, getBrandEmail, getBrandTagline, getCopyright } from '@/config/brand';

export const useBrand = () => {
  return {
    // Direct access to config
    config: BRAND_CONFIG,
    
    // Common getters
    name: getBrandName(),
    email: getBrandEmail(),
    tagline: getBrandTagline(),
    copyright: getCopyright(),
    
    // Formatted strings for common use cases
    fullTitle: (pageTitle?: string) => 
      pageTitle ? `${pageTitle} | ${getBrandName()}` : getBrandName(),
    
    supportEmail: `mailto:${getBrandEmail()}`,
    
    metaDescription: BRAND_CONFIG.description,
    
    // Logo alt text
    logoAlt: `${getBrandName()} Logo`,
    
    // Common page titles
    pageTitle: {
      home: getBrandName(),
      login: `Login | ${getBrandName()}`,
      signup: `Sign Up | ${getBrandName()}`,
      dashboard: `Dashboard | ${getBrandName()}`,
      profile: `Profile | ${getBrandName()}`,
      jobs: `Jobs | ${getBrandName()}`,
      providers: `Service Providers | ${getBrandName()}`,
    }
  };
};